@if (status) {
  @if (status.running; as job) {
    <app-validation-toast state="Info" [inline]="true" [persistent]="true" [autoMessage]="runningText(job)">
      <dx-progress-bar [min]="0" [max]="100" [value]="percent" [showStatus]="false" width="100%"></dx-progress-bar>
    </app-validation-toast>
  } @else if (status.queuedCount > 0) {
    <app-validation-toast state="Info" [inline]="true" [persistent]="true" [autoMessage]="waitingText()"></app-validation-toast>
  }
  @for (job of status.recentlySucceeded; track job.id) {
    <app-validation-toast state="Success" [inline]="true" [autoMessage]="doneText(job)"></app-validation-toast>
  }
  <!-- Hidden while its retry/dismiss runs; a failed call shows it again as a new toast. -->
  @for (job of status.failed; track job.id) {
    @if (!busy.has(job.id)) {
      <app-validation-toast
        state="Error"
        [inline]="true"
        [persistent]="true"
        [closable]="true"
        [autoMessage]="failedText(job)"
        [actionText]="retryText"
        (action)="retry(job)"
        (closed)="dismiss(job)"
      ></app-validation-toast>
    }
  }
}
